__turbopack_context__.v({
  "disclaimer": "a-M7nq_disclaimer",
  "grid": "a-M7nq_grid",
  "highlights": "a-M7nq_highlights",
  "skeletonCard": "a-M7nq_skeletonCard",
  "viewMoreLink": "a-M7nq_viewMoreLink",
});
